import axios, { AxiosRequestConfig } from 'axios';

import { getUserInfo } from 'Lib/logging/getUserInfo';

const reportAppErrorEvent = async (event: ErrorEvent | PromiseRejectionEvent): Promise<void> => {
    const user = getUserInfo();

    let message = '';
    let stack = '';
    if (event instanceof ErrorEvent) {
        message = event.message;
        stack = event.error.stack;
    } else if (event instanceof PromiseRejectionEvent) {
        message = event.reason.message;
    }

    const req: AxiosRequestConfig = {
        method: 'POST',
        url: '/log',
        data: {
            level: 'error',
            message,
            stack,
            userId: user?.userId || '',
            userEmail: user?.email || '',
            username: user?.username || ''
        }
    };

    try {
        await axios(req);
    } catch (error) {
        console.error('Could not send error to loggin service');

        return;
    }
};

export { reportAppErrorEvent };